import {Component} from '@angular/core';

@Component({
  templateUrl: './unsaved-changes-dialog.component.html',
})
export class UnsavedChangesDialogComponent {

}
